// Works out how an order was paid (Stripe / Rapyd / Airwallex / PayNow / Cash) from the
// track_order and track_order_history rows, so every order screen labels it the same way.
import stripeLogo from "../assets/images/stripe_logo.png";
import rapydLogo from "../assets/images/rapyd_logo.png";
import warelyPayLogo from "../assets/images/warely_pay_icon.png";

const GATEWAYS = [
  { key: "stripe", label: "Stripe", logo: stripeLogo },
  { key: "rapyd", label: "Rapyd", logo: rapydLogo },
  { key: "airwallex", label: "Warely Pay", logo: warelyPayLogo },
];

const toLower = (value) =>
  value === undefined || value === null ? "" : String(value).trim().toLowerCase();

// last_4_card_digits comes back masked ("**** **** **** 4242"), or with no digits at all
// for hosted-checkout payments.
export const getCardLast4 = (value) => {
  const match = String(value || "").match(/(\d{4})\s*$/);
  return match ? match[1] : "";
};

const titleCase = (value) =>
  String(value).trim().replace(/\b\w/g, (c) => c.toUpperCase());

// Returns { label, logo, last4 } for display. logo is null when there is no gateway logo.
export const getPaymentDisplay = (order) => {
  const method = toLower(order?.paymentType);
  const cardType = toLower(order?.card_type);
  const source = `${toLower(order?.payment_gateway)} ${cardType}`;
  const last4 = getCardLast4(order?.last_4_card_digits);

  const gateway = GATEWAYS.find((g) => source.includes(g.key));
  if (gateway) return { label: gateway.label, logo: gateway.logo, last4 };

  if (method === "paynow" || cardType === "paynow") return { label: "PayNow", logo: null, last4: "" };
  if (method === "cash") return { label: "Cash", logo: null, last4: "" };

  return { label: cardType ? titleCase(order.card_type) : "Card", logo: null, last4 };
};
